import styled, { DefaultTheme } from 'styled-components/macro';

import ButtonIcon from 'components/ButtonIcon/ButtonIcon';

export const getOverlayStyles = (theme: DefaultTheme) => ({
  backgroundColor: theme.colors.rgba.variant1,
});

export const getContentStyles = (theme: DefaultTheme, isMobile: boolean, overrideStyles = {}) => ({
  width: 'auto',
  borderRadius: isMobile ? theme.borders.none : theme.radius.sm,
  backgroundColor: theme.colors.primary.variant3,
  ...overrideStyles,
});

export const CloseButtonIconStyled = styled(ButtonIcon)`
  position: absolute;
  top: 24px;
  right: 16px;
  z-index: 1;
`;
